
                import "css-modules://src_components_navigation_navigation"
                export default {"Main":"_b79ace","Open":"_898f95","Bg":"_f39bf3","Visible":"_92762e"}
            